import React from 'react'
import {
  Sidebar,
  List,
} from './index'
import organizations from '../../../database/organizations.json'
import { FloatingFilter } from '../../../components'

const MainContentMobile = ({byId, organizationIds}) => {
  const [filtered, setFiltered] = React.useState(false)
  const [data, setData] = React.useState(organizations)

  React.useEffect(() => {
    if(filtered){
      setData(organizations.slice(0, 3))
    }else{
      setData(organizations)
    }
  }, [filtered])

  React.useEffect(() => {
    if(byId && organizationIds){
      const result = organizations.filter(d => organizationIds.includes(d.id))
      setData(result)
    }
  }, [byId, organizationIds])

  return (
    <div>
      <section className="container mx-auto pt-5">
        <div className="flex flex-wrap -mx-4 pb-5 lg:pb-16 lg:py-16">
          <aside className="hidden lg:block w-3/12 px-4">
            <Sidebar filtered={filtered} setFiltered={setFiltered}/>
          </aside>
          <main className="w-full lg:w-9/12 px-4">
            <List data={data}/>
          </main>
        </div>
      </section>
      <FloatingFilter onSubmit={() => setFiltered(true)}/>
    </div>
  )
}

export { MainContentMobile }
